import blackPb from "../assets/BlackPB.webp"
import Pb from "../assets/T4PB.webp"


export const Images = [
    {
        id: 1,
        image: blackPb,
        desc : "black slip"
    } ,
    {
        id: 2,
        image: Pb,
        desc : "black slip"
    } 
]